<template>
  <div style="margin:20px">
    <FiPageRail title="Route History" />
    <!-- filter bar: wrapping groups, so a phone gets stacked full-width-safe
         controls instead of one overflowing centered line (the old literal
         "|" separators went with it -- they read as breakage mid-wrap) -->
    <div class="map-controls">
      <span class="mc-group">
        <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
        <date-picker class="mc-datepicker" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>
        <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      </span>
      <template v-if="!loading_filters">
        <span v-if="route_options.length > 0" class="mc-group">
          <span>Select Route:</span>
          <b-form-select v-model="route_filter" :options="route_options" class="mc-select mc-select--route"/>
        </span>
        <span v-if="vehicle_options.length > 0" class="mc-group">
          <span>Select Vehicle:</span>
          <b-form-select v-model="vehicle_id" :options="vehicle_options" class="mc-select mc-select--vehicle"/>
        </span>
        <span class="mc-group">
          <span>Buffer:</span>
          <b-form-select v-model="minutes_buffer" :options="minutes_buffer_options" class="mc-select mc-select--buffer"/>
        </span>
        <b-button v-on:click.prevent="load_data()">Load Results</b-button>
      </template>
      <span v-else class="mc-group">
        loading routes & vehicles
        <b-spinner style="width: 2rem; height: 2rem;" label="Loading..."></b-spinner>
      </span>
    </div>

    <br/>
    <div v-if="!loading">
      <div v-if="routes.length > 0" ref="test" class="row" style="margin: 0px">
        <div class="col" style="overflow-y:scroll; max-height: 900px; min-width: 480px; max-width: 500px">
          <br/>
          <div style="font-weight: bold; font-size: 22px; color: var(--fi-rail-accent); margin-bottom: 10px;">{{summary.result_vehicle}} {{routes.length}} Routes On {{summary.result_date}}</div>

          <div v-if="route.duration != '0m'" class="route-item" v-for="route in routes" style="text-align: left; padding:8px; border-top: 1px solid black;">
            <div :style="route.selected ? 'background-color: #E6E7E9; padding: 2px 5px 2px 5px': ''">
              <span v-on:click="toggle_route(route)" >
                <span style="font-size: 16px; font-weight: bold;">{{route.name | trim(25)}} <span v-if="route.vehicle">- Veh# {{route.vehicle.name | trim(15)}}</span></span>
                <span v-if="route.duration" style="float:right; font-size: 16px;font-weight: bold;">{{route.duration}}</span>
                <br/>
                <span v-if="!route.selected">
                    <span v-if="route.stops[0].name" style="color: green; font-size: 16px; font-weight: bold;">{{route.stops[0].name | trim(45)}}</span>
                    <span style="float:right; font-size: 16px;font-weight: bold;">{{route.stops[0].departureTime}}</span>
                    <br/>
                    <span v-if="route.stops[route.stops.length-1].name" style="color: darkred; font-size: 16px; font-weight: bold;">{{route.stops[route.stops.length-1].name | trim(45)}}</span>
                    <span style="float:right; font-size: 16px;font-weight: bold;">{{route.stops[route.stops.length-1].arrivalTime}}</span>
                </span>
                <span v-if="route.selected && route_loading">
                  <b-spinner style="width: 1rem; height: 1rem;" label="Loading..."></b-spinner>
                </span>
              </span>
              <span v-if="route.selected && !route_loading">
                <div style="font-size: 16px; font-weight: bold; margin-top: 5px; border-bottom: 1px solid black">
                  <span>Stop Name</span>
                  <span style="float:right; font-size: 16px;">Arrive | Depart</span>
                </div>

                <div class="stop-item" @click="show_stop(route,stop)" :style="selected_stop==stop.id ? 'background-color: #D6D7D9': ''" v-for="stop,idx in route.stops" style="font-size: 16px; font-weight: bold;">
                  <div v-if="idx==0" style="color: green">{{stop.name | trim(50)}}</div>
                  <div v-else-if="idx==route.stops.length-1" style="color: darkred">{{stop.name | trim(50)}}</div>
                  <div v-else>{{stop.name | trim(50)}}</div>
                  <div style="text-align:right; font-size: 16px;">planned: {{stop.arrivalTime | space(9)}}&nbsp;| {{stop.departureTime | space(9)}}&nbsp;&nbsp;</div>
                  <div style="text-align: right; font-size: 16px; color: var(--fi-rail-accent);">actual: {{stop.otpArrivalTime | space(9)}}&nbsp;| {{stop.otpDepartureTime | space(9)}}&nbsp;&nbsp;</div>
                  <div v-if="stop.otpStopTime" style="color: var(--fi-rail-accent); text-align: right; font-size: 16px;">stop time: {{stop.otpStopTime}}&nbsp;({{stop.otpStopDuration}})&nbsp;&nbsp;</div>
                  <div v-if="stop.otpMinimumSpeed" style="color: var(--fi-rail-accent); text-align: right; font-size: 16px;">min speed: {{stop.otpMinimumSpeed}}&nbsp;&nbsp;</div>
                  <br/>
                </div>
              </span>
            </div>
          </div>
        </div>
        <div class="col" style="border: none; padding-right:0px !important; padding-left:0px !important">
          <GmapMap id="map" ref="mapRef"
                   :zoom="zoom"
                   :center="center"
                   :options="themed_map_options"
                   style="width:100%;  height: 900px;"
          >
            <GmapMarker
                v-for="(marker,idx) in markers"
                :position="marker.position"
                :label="marker.label"
                :draggable="false"
                :clickable="true"
                :icon="marker.icon"
                @mouseover="openInfoWindowTemplate(marker.title)"
                @mouseout="infoWindow.open=false"
            />
            <GmapInfoWindow
                :options="{ pixelOffset: { width: 0, height: -15 } }"
                :position="infoWindow.position"
                :opened="infoWindow.open"
            >
              <div v-html="infoWindow.template"></div>
            </GmapInfoWindow>
          </GmapMap>
        </div>
      </div>
      <div v-else-if="summary && vehicle_id && routes.length == 0" style="font-weight: bold; font-size: 24px"><br/><br/>no routes found for {{summary.result_vehicle}} on {{summary.result_date}}</div>
      <div v-else-if="summary && routes.length == 0" style="font-weight: bold; font-size: 24px"><br/><br/>no routes found on {{summary.result_date}}</div>
    </div>
    <div v-if="loading">
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>
</template>
<script>
import {get_vehicle_route_history, get_vehicle_list, get_vehicle_route_locations, get_route_list} from '../networking/apis'
import {justDate} from "../helpers/dates";
import moment from "moment";
import {mapState} from "vuex";
import {gmapApi} from "vue2-google-maps";
import {DARK_MAP_STYLES} from "../assets/dark_map_styles";

export default {
  name: 'vehicle_route_history',
  components: {},
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      minutes_buffer: '30',
      selected_route: null,
      route_filter: '',
      //details_fromDate: justDate(moment()),
      details_fromDate: justDate(moment().subtract(1, 'days')),
      items: [],
      items_full: [],
      vehicle_id: '',
      summary: null,
      vehicle_options: [],
      route_options: [],
      routes: [],
      addresses: [],
      loading: false,
      loading_filters: true,
      loading_route: false,
      center: null,
      zoom: null,
      markers: [],
      markers_full: [],
      route_loading: false,
      selected_stop: null,
      geofencesAdded: false,
      minutes_buffer_options: [
        { value: '5', text: '5m' },
        { value: '15', text: '15m' },
        { value: '30', text: '30m' },
        { value: '60', text: '1h' },
        { value: '120', text: '2h' },
      ],
      infoWindow: {
        position: {lat: 0, lng: 0},
        open: false,
        template: ''
      },
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(0, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },
      mapStyle: {
        styles: [
          {
            "featureType": "landscape",
            "stylers": [
              {"color": "#F3F4F9"}
            ]
          }, {
            "featureType": "water",
            "stylers": [
              {"color": "#C1CDE4"}
            ]
          },
          {
            "featureType": "landscape.natural.terrain",
            "stylers": [
              {"color": "#E0EDCA"}
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [{color: '#DDDDDD'}]
          },
          {
            featureType: 'road',
            elementType: 'geometry.fill',
            stylers: [{color: '#FFFFFF'}]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [{color: '#FEF8D6'}]
          },
          {
            featureType: 'transit',
            stylers: [{"visibility": "off"}]
          },
          {
            featureType: 'poi',
            stylers: [{"visibility": "off"}]
          },
        ]
      }
    }
  },
  async created() {
    await this.check_features()
  },
  methods: {
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
      this.details_toDate = moment(this.details_toDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    async check_features() {
      this.summary = null
      this.items = []
      this.items_full = []
      this.markers = []
      this.routes = []
      this.addresses = []

      if (this.$route.query.date) {
        this.details_fromDate = this.$route.query.date
      }

      this.loading_filters = true;

      await this.load_vehicles()
      await this.load_routes()

      if (this.$route.query.vehicleId) {
        this.vehicle_id = this.$route.query.vehicleId
      }

      this.loading_filters = false;

      if (this.$route.query.routeName) {
        this.route_filter = this.route_options.filter(item => item.text == this.$route.query.routeName)[0].value
        await this.load_data()
      }
    },
    openInfoWindowTemplate(selected_name) {
      const loc = this.items.filter(item => item.name == selected_name)[0]

      if (loc != null) {
        const position = {
          lat: Number(loc.lat),
          lng: Number(loc.lng),
        };
        this.infoWindow.position = position
        this.infoWindow.template = loc.marker_html
        this.infoWindow.open = true
      }
    },
    show_stop(route, stop) {
      this.selected_stop = stop.id;
      
      if (!route['selected'])
        this.toggle_route(route);

      this.center = {
        lat: Number(stop.map_info.lat),
        lng: Number(stop.map_info.lng),
      };

      if (stop.startMs && stop.endMs)
        this.markers = this.markers_full.filter(item => (stop.startMs <= item.timeMs && item.timeMs <= stop.endMs))
      else if (stop.startMs)
        this.markers = this.markers_full.filter(item => (stop.startMs <= item.timeMs))
      else if (stop.endMs)
        this.markers = this.markers_full.filter(item => (item.timeMs <= stop.endMs))
      
      if (this.zoom == 17) {
        this.zoom = 16
      } else {
        this.zoom = 17
      }
      this.$forceUpdate();
    },
    async toggle_route(route) {
      this.route_loading = true;
      this.selected_stop = null;
      route['selected'] = !route['selected'];

      for (const currroute of this.routes) {
        if (currroute.startMs != route.startMs)
          currroute['selected'] = false
      }

      if (route['selected']) {
        this.selected_route = route.startMs

        this.markers = [];

        this.$forceUpdate();

        let tmp_markers = [];
        let cnt = 0;

        const {value: {data = []}} = await get_vehicle_route_locations(this.user.tenant, route.id, this.minutes_buffer)
        this.items = data.results

        for (const loc of this.items) {
          const position = {
            lat: Number(loc.lat),
            lng: Number(loc.lng),
          };

          if (loc.headingDegrees != 0 && loc.speedMilesPerHour > 0)
            tmp_markers.push({position: position, timeMs: loc.timeMs, title: loc.name, icon: this.arrowSymbol(loc, .6)});
          else
            tmp_markers.push({position: position, timeMs: loc.timeMs, title: loc.name, icon: this.mapSymbol(loc, 0.8)});
          cnt += 1;
        }

        this.markers_full = tmp_markers;
        this.markers = tmp_markers;

        if (this.markers.length > 0)
          this.fit_marker_bounds();

        this.addGeofences();

      } else {
        this.markers = this.markers_full;
        this.fit_marker_bounds();
      }
      this.$forceUpdate();

      this.route_loading = false;
    },
    fit_marker_bounds() {
      if (this.$refs.mapRef) {

        let bounds = new google.maps.LatLngBounds();
        for (const loc of this.markers) {
          bounds.extend(loc.position);
        }

        this.$refs.mapRef.$mapObject.fitBounds(bounds, 100);
      }
    },
    async load_vehicles() {
      const {value: {data = []}} = await get_vehicle_list(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
      this.vehicle_options = data
    },
    async load_routes() {
      const {value: {data = []}} = await get_route_list(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
      this.route_options = data
    },
    async load_data() {
      try {
        this.markers = []
        // if (!this.route_filter && !this.vehicle_id) {
        //   alert("please select a route or vehicle")
        //   return
        // }
        this.loading = true

        const {value: {data = []}} = await get_vehicle_route_history(this.user.tenant, this.route_filter, this.vehicle_id, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),this.minutes_buffer)
        this.summary = data.summary
        this.items = data.results
        this.routes = data.routes
        this.addresses = data.addresses

        this.zoom = this.summary.zoom
        if (this.items && this.items.length > 0) {
          for (const loc of this.items) {
            const position = {
              lat: Number(loc.lat),
              lng: Number(loc.lng),
            };

            this.markers.push({position: position, timeMs: loc.timeMs, title: loc.name, icon: this.mapSymbol(loc, 1.0)});
          }
        }

        if (this.markers.length > 0)
          this.center = this.markers[Math.round(this.markers.length / 2)].position;
        else if (this.addresses.length > 0) {
          this.center = {
            lat: Number(this.addresses[0].lat),
            lng: Number(this.addresses[0].lng),
          };
        }
        this.zoom = 7
        this.markers_full = this.markers;
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async addGeofences() {

      console.log("adding geofences")
      // if (this.geofencesAdded)
      //   return

      if (!this.$refs.mapRef) {
        while(true) {
          let cnt=0
          while(cnt<10) {
            if (this.$refs.mapRef)
              break;
            await this.sleep(500);
            console.log("waiting for mapref: " + cnt)
            cnt++;
          }
        }
      }

      if (this.$refs.mapRef) {
        console.log("adding geofences: " + this.addresses.length)
        for (const address of this.addresses) {
          if (address.type.indexOf('circle') != -1) {

            const fill_color = "#458FE5";

            const cityCircle = new google.maps.Circle({
              title: address.name,
              strokeColor: "#458FE5",
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: fill_color,
              fillOpacity: 0.1,
              map: this.$refs.mapRef.$mapObject,
              center: {lat: address.lat, lng: address.lng},
              radius: address.radius,
            });
          } else {
            const shape = new google.maps.Polygon({
              title: address.name,
              paths: address.vertices,
              strokeColor: "#458FE5",
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: "#458FE5",
              fillOpacity: 0.1,
              map: this.$refs.mapRef.$mapObject,
            });
          }
        }
        this.geofencesAdded = true;
      }
    },
    mapSymbol(loc, scale) {
      return {
        path: "M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0",
        scale: scale,
        strokeColor: "#29C68A",
        fillColor: loc.speedMilesPerHour == 0 ? "darkred" : "#29C68A",
        fillOpacity: .5,
      }
    },
    arrowSymbol(loc, scale) {
      return {
        path: "M0,0 L-6,14 L0,0 L6,14 L0,10 L-6,14",
        scale: scale,
        strokeColor: "#29C68A",
        fillColor: "#29C68A",
        fillOpacity: .5,
        rotation: Number(loc.headingDegrees)
      }
    },
    stopSymbol(loc, scale) {
      return {
        path: "M0,0 L-6,14 L0,0 L6,14 L0,10 L-6,14",
        scale: scale,
        strokeColor: "steelblue",
        fillColor: "steelblue",
        fillOpacity: .5,
        rotation: Number(loc.rotation)
      }
    },
  },
  computed: {
    ...mapState({
      user: state => state.profile.user
    }),
    google: gmapApi,
    // the light mapStyle in data stays untouched; midnight users get the
    // dark basemap (in-shell map pages only -- standalone maps stay light)
    themed_map_options() {
      const midnight = (this.$store.state.profile || {}).site_theme === 'midnight'
      return midnight ? { ...this.mapStyle, styles: DARK_MAP_STYLES } : this.mapStyle
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    route_filter() {
      if (this.route_filter != '')
        this.vehicle_id = ''
    },
    vehicle_id() {
      if (this.vehicle_id != '')
        this.route_filter = ''
    },
    details_fromDate(target_from_date) {
      this.load_vehicles()
      this.load_routes()
    },
    // vehicle_id() {
    //   if (this.vehicle_id && this.vehicle_id != '')
    //     this.load_data()
    //   else
    //     this.items = []
    // }
  }
}
</script>
<style scope>

.route-item:hover {
  background-color: #E6E7E9;
}
.stop-item:hover {
  background-color: #D5D5D5;
}

</style>
<style scoped>
/* filter bar geometry (mobile-friendly wrap). new rules go in this scoped
   block; the "style scope" block above is a long-standing typo that leaks
   globally, so nothing new should join it. */
.map-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px 18px;
  margin-top: 25px;
  font-size: 18px;
  font-weight: bold;
}
.mc-group {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
}
.mc-datepicker { font-size: 20px; font-weight: bold; width: 140px; }
.mc-select { font-size: 18px; font-weight: bold; }
.mc-select--route { width: 250px; }
.mc-select--vehicle { width: 150px; }
.mc-select--buffer { width: 90px; }
@media (max-width: 640px) {
  .map-controls { justify-content: flex-start; font-size: 15px; gap: 6px 14px; }
  /* 16px floor keeps ios safari from zooming the viewport on focus */
  .mc-datepicker, .mc-select { font-size: 16px; }
  .mc-select, .mc-select--route { max-width: 100%; }
}
</style>
